// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back[data-v-0fab7133]{margin-bottom:45px}@media(max-width:960px){.back[data-v-0fab7133]{margin-top:30px;margin-bottom:10px}}.back[data-v-0fab7133]:hover{background-color:#e5e5e5;box-shadow:0 4px 10px rgba(0,0,0,.18)}", ""]);
// Exports
module.exports = exports;
